import { styled } from "@mui/material";

const Anchor = styled("a")(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: "underline",
  "&:hover": {
    color: theme.palette.primary.dark,
  },
  "&:focus-visible": {
    outline: `2px solid ${theme.palette.primary.main}`,
  },
  "&:active": {
    color: theme.palette.secondary1[100],
  },
}));

export type AnchorProps = React.ComponentProps<typeof Anchor>;

export default Anchor;
